var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconstatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.00001C0 4.03107 4.03107 0 9.00001 0C13.969 0 18 4.03107 18 9.00001C18 13.969 13.969 18 9.00001 18C4.03107 18 0 13.969 0 9.00001ZM8.53104 10.5691V14.3026C8.53104 14.7806 9.17133 14.9339 9.38776 14.501L12.5982 8.08015C12.7425 7.78256 12.526 7.43085 12.1924 7.43085H9.90179V3.65229C9.90179 3.17433 9.26151 3.02103 9.05409 3.44488L5.73545 9.91082C5.57312 10.2084 5.79858 10.5691 6.13224 10.5691H8.53104Z",
    fill: "#F43C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconstatus);
export default __webpack_public_path__ + "static/media/iconstatus.469bceb902154ed680212993dcf2488e.svg";
export { ForwardRef as ReactComponent };